import { defineComponent as _defineComponent } from 'vue'

const __default__ = { name: 'attributed-purchases-drawer' }

import { onBeforeUnmount, watch } from 'vue'
import { formatGroupDate } from '@/plugins/dates'
import { formatCurrency, getGroupSettings } from '@/util/currencyFormat'


export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
  show: { type: Boolean, default: false },
  rows: { type: Array as () => any[], default: () => [] },
  loading: { type: Boolean, default: false },
  page: { type: Number, default: 1 },
  perPage: { type: Number, default: 25 },
  total: { type: Number, default: 0 },
  canDownload: { type: Boolean, default: false },
  exporting: { type: Boolean, default: false }
},
  emits: ["close", "update:page", "download"],
  setup(__props, { emit }: { emit: ({
  (e: 'close'): void
  (e: 'update:page', page: number): void
  (e: 'download'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props





const columns = [
  { key: 'customer', label: 'Customer' },
  { key: 'order_number', label: 'Order' },
  { key: 'timestamp', label: 'Purchased' },
  { key: 'paid', label: 'Paid', align: 'right' as const }
]

function customerName(row: any) {
  return `${row.first_name || ''} ${row.last_name || ''}`.trim() || 'Customer'
}

// Group date format, including the show day of week setting (formatGroupDate default)
function formatDate(value: string) {
  return value ? formatGroupDate(value) : ''
}

function formatMoney(value: number) {
  const gs = getGroupSettings()
  return formatCurrency(value, {
    currency: gs.currency,
    currencyFormat: gs.currency_format,
    numberFormat: gs.number_format
  })
}

// BaseDrawer does not handle ESC; each consumer adds its own listener
function onEscKey(e: KeyboardEvent) {
  if (e.key === 'Escape') emit('close')
}
watch(() => props.show, (val) => {
  if (val) document.addEventListener('keydown', onEscKey)
  else document.removeEventListener('keydown', onEscKey)
})
onBeforeUnmount(() => document.removeEventListener('keydown', onEscKey))

return { __sfc: true,props, emit, columns, customerName, formatDate, formatMoney, onEscKey }
}

})